import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, TextField } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import clsx from 'clsx';
import { resetPassword } from '../../utils/AccountsAPI';
import { trackPromise } from 'react-promise-tracker';
import { toastError } from '../../utils/Functions';
import { ChevronRight, Save } from '@material-ui/icons';
import AppBarContext from '../../contexts/AppBarContext';
import useLoadContext from '../../hooks/useLoadContext';

const useStyles = makeStyles((theme) => ({
  //for material UI Icons
  confirmEmail: {
    padding: '15px',
  },
  header: {},
  paper: {
    margin: 'auto',
    height: '100%',
    minWidth: '200px',
    maxWidth: '200px',
    padding: theme.spacing(2),
    border: '5px',
    textAlign: 'center',
    display: 'flex',
    verticalAlign: 'middle',
    marginLeft: theme.spacing(2),
  },
  textPaper: {
    minWidth: '200px',
    maxWidth: '600px',
    padding: theme.spacing(2),
    border: '5px',
    textAlign: 'center',
    display: 'inline-grid',
    backgroundColor: 'inherit',
    color: 'white',
  },
  elementPaper: {
    minWidth: '200px',
    maxWidth: '800px',
    padding: theme.spacing(2),
    border: '5px',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
  },
  cardContent: {
    color: 'white',
    fontSize: '1.75em',
    padding: '1vh',
    fontWeight: 'bold',
    verticalAlign: 'middle',
    width: '100%',
    margin: 'auto',
  },
  textField: {
    color: 'white',
    float: 'left',
    width: '100%',
  },
  button: {
    marginTop: theme.spacing(1),
    margin: 'auto',
  },
  primary: {
    backgroundColor: theme.palette.primary.main,
  },
  secondary: {
    backgroundColor: theme.palette.secondary.main,
  },
}));

export default function ResetPassword(props) {
  const [username, setUsername] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordsDontMatch, setPasswordsDontMatch] = useState(false);
  const [confirmed, setConfirmed] = useState(true);

  const classes = useStyles();
  const token = props.location.search.substring(props.location.search.indexOf('?token=') + 7);

  useLoadContext(AppBarContext, { title: 'Reset Password' });

  const validatePassword = () => {
    if (newPassword !== confirmPassword && newPassword !== '' && confirmPassword !== '') {
      props.toast.error('Error: Passwords do not match.', {
        position: 'bottom-left',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      setPasswordsDontMatch(true);
    } else {
      setPasswordsDontMatch(false);
    }
  };

  const sendPasswordReset = () => {
    if (token.length > 0) {
      trackPromise(resetPassword(username, token, newPassword)).then(
        () => {
          props.toast.success('Password reset successfully!', {
            position: 'bottom-left',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          setConfirmed(true);
        },
        (err) => {
          toastError(props.toast, err);
        }
      );
    } else {
      toastError(props.toast, 'Error: No token available.');
    }
  };

  const keyPress = (e) => {
    if (e.key === 'Enter') {
      sendPasswordReset();
    }
  };

  const resetForm: JSX.Element[] = [];

  var passReq = <Typography>The password must be 6+ characters and include an uppercase letter, a lowercase letter, a number, and a special character.</Typography>;

  var uname = (
    <TextField
      id={'Username'}
      label={'Username'}
      onChange={(e) => setUsername(e.target.value)}
      onKeyPress={keyPress}
      type={'text'}
      className={classes.textField}
      value={username}
      margin='dense'
      variant='outlined'
    />
  );

  var newPass = (
    <TextField
      id={'New Password'}
      label={'New Password'}
      error={passwordsDontMatch}
      onChange={(e) => setNewPassword(e.target.value)}
      onBlur={validatePassword}
      onKeyPress={keyPress}
      type={'password'}
      className={classes.textField}
      value={newPassword}
      margin='dense'
      variant='outlined'
    />
  );

  var confPass = (
    <TextField
      id={'Confirm Password'}
      label={'Confirm Password'}
      error={passwordsDontMatch}
      onChange={(e) => setConfirmPassword(e.target.value)}
      onBlur={validatePassword}
      onKeyPress={keyPress}
      type={'password'}
      className={classes.textField}
      value={confirmPassword}
      margin='dense'
      variant='outlined'
    />
  );

  var reset = (
    <div>
      <Button onClick={sendPasswordReset} variant='contained' className={clsx(classes.button)}>
        <Save />
        <div style={{ minWidth: '10px' }}></div>
        Reset
      </Button>
      {confirmed ? (
        <Button
          onClick={() => {
            props.history.push('/Login');
          }}
          variant='contained'
          color='primary'
          className={clsx(classes.button)}
          style={{ marginLeft: '8px' }}
        >
          Login
          <div style={{ minWidth: '10px' }}></div>
          <ChevronRight />
        </Button>
      ) : null}
    </div>
  );

  resetForm.push(passReq);
  resetForm.push(<form>{[uname, newPass, confPass]}</form>);
  resetForm.push(reset);

  return (
    <div className={classes.confirmEmail}>
      <Grid container direction='row' spacing={3} justify='center'>
        <Paper className={classes.elementPaper}>
          <Typography className={classes.header} variant='h3'>
            Reset Password
          </Typography>
          <Paper className={classes.textPaper} elevation={0}>
            {token.length <= 0 ? (
              <Typography>We have sent an email with a password reset link to your email address. In order to reset your password, please click the link.</Typography>
            ) : (
              resetForm
            )}
          </Paper>
        </Paper>
      </Grid>
    </div>
  );
}
